import { Component } from 'react';
import { randomColorsArray } from '../../global/row';
import { getAvatarName, getColorIndex } from '../../helpers/common';
import { TextWrapper, UserLogoWrapper } from './styles';
import { AVATAR_BORDER } from '../../global/constants';
import Image, { ImageKey } from '../image';

interface Props {
  imgSrc: string | ImageKey;
  size?: number;
  name: string;
  email?: string;
  borderVariant?: (typeof AVATAR_BORDER)[keyof typeof AVATAR_BORDER];
  className?: string;
  borderRadius?: string;
  avatarSingleLetter?: boolean;
}

class Avatar extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const props: Props = this.props;
    const { imgSrc, size = 38, name, borderVariant, className, borderRadius = 'var(--border-radius-full)' } = props;
    const avatarName = getAvatarName(name, props.avatarSingleLetter);
    const colorIndex = getColorIndex(avatarName);
    const randColor = randomColorsArray[colorIndex];
    return (
      <UserLogoWrapper>
        {imgSrc ? (
          <Image
            imageUrl={imgSrc}
            borderVariant={borderVariant}
            alt={name}
            className={className}
            borderRadius={borderRadius}
            width={size}
            height={size}
            objectFit='cover'
          />
        ) : (
          <TextWrapper
            size={size}
            randColor={randColor}
            borderVariant={borderVariant}
            className={className}
            borderRadius={borderRadius}>
            <span>{avatarName}</span>
          </TextWrapper>
        )}
      </UserLogoWrapper>
    );
  }
}

export default Avatar;
